import styled from 'styled-components';

export const StyledCredentialCard = styled.div`
  > span {
    font-weight: 600;
    display: inline-block;
    margin-bottom: 7px;
    padding-left: 8px;

    .required {
      color: red;
      padding-left: 0;
    }
  }

  .cc-label {
    display: flex;
    align-items: center;
    position: relative;

    span {
      width: 10px;
      height: 5px;
      position: relative;
      top: -4px;
      left: 2px;
    }
  }
`;

export const StyledCredentialCardTable = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledCredentialCardTableHeader = styled.div`
  display: flex;
  align-items: center;
  background-color: var(--color-off-white);
  border-top: 1px solid var(--color-pale-gray);

  > div {
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    padding: 11px 0;

    &:first-of-type {
      width: 194px;
    }

    &:nth-of-type(2) {
      width: 283px;
    }

    &:last-of-type {
      width: 223px;
    }
  }
`;

export const StyledCredentialCardTableBody = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledCredentialCardTableRow = styled.div`
  display: flex;
  align-items: center;

  &:nth-child(odd) {
    border-top: 1px solid var(--color-pale-gray);
    border-bottom: 1px solid var(--color-pale-gray);
  }

  .row {
    text-align: center;
    padding: 5px;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: var(--color-medium-gray);

    > div {
      margin-bottom: 0;

      > .MuiTextField-root {
        > .MuiInputBase-root {
          border-radius: 0;
          height: 30px;
          overflow: hidden;

          > input {
            border-radius: 0 !important;
            height: 30px !important;
            font-weight: 400;
            font-size: 14px;
            line-height: 21px;
          }
        }
      }

      > .datePickerWrapper {
        border-radius: 0;
        height: 30px !important;
        overflow: hidden;

        .react-datepicker-wrapper {
          .react-datepicker__input-container {
            > input {
              border-radius: 0;
              min-height: 30px !important;
            }
          }
        }
      }
    }
  }

  .type {
    width: 194px;

    > p {
      > span {
        .required {
          color: red;
          padding-left: 0;
        }
      }
    }
  }

  .number {
    width: 283px;
  }

  .date {
    width: 223px;
  }

  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;
